"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSTL006_List = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const styled_components_1 = __importDefault(require("styled-components"));
const server_1 = require("../../../server");
const layout_1 = require("../../base/layout");
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const action_1 = require("../../menu/action");
const StudentStatusControls_1 = require("./DSTL006_List_Child/StudentStatusControls");
const WeeklyStatusSection_1 = require("./DSTL006_List_Child/WeeklyStatusSection");
const OverallStatusSection_1 = require("./DSTL006_List_Child/OverallStatusSection");
const pdf_1 = require("./DSTL006_List_Child/pdf");
const popup_1 = require("../../base/popup");
const ScoreReportViewer_1 = require("../DSTL001/component/DSTL001_Detail_Child/ScoreReportViewer");
const DSTL006ListStyled = styled_components_1.default.div `
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	gap: 20px;
	overflow-y: auto;

	section {
		display: flex;
		flex-direction: column;
		gap: ${({ $isMobile }) => ($isMobile ? '20px' : '12px')};
	}

	.student-status-wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: ${({ $isMobile }) => ($isMobile ? '16px' : '24px')};
		padding: ${({ $isTablet }) => ($isTablet ? '20px' : '0')};
	}

	.top-nav-placeholder {
		height: ${({ $isMobile }) => ($isMobile ? '0' : '8px')};
	}
		
	.empty_data {
		min-height: 200px;
	}
`;
const detailStatusDefaults = {
    attendance: ['attend', 'late', 'absent'],
    test: ['submit', 'not-submit'],
    assignment: ['submit', 'not-submit'],
};
const PIE_CHART_COLORS = ['#51c7d2', '#c9dba9', '#f2c8a6', '#9ab2d0', '#dbb3d8'];
const formatCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = `${now.getMonth() + 1}`.padStart(2, '0');
    const date = `${now.getDate()}`.padStart(2, '0');
    const hours = `${now.getHours()}`.padStart(2, '0');
    const minutes = `${now.getMinutes()}`.padStart(2, '0');
    return `${year}-${month}-${date} ${hours}:${minutes}`;
};
// 기본 조회 기간: 최근 7일(오늘 포함). 주차 드롭박스 → 기간 직접 지정 전환(서버 확정:
// 지정 기간을 그대로 state/* API start_after/start_before 로 전달) — 시즌 경계 문제 해소.
// '주 시작(일요일)~오늘'은 일요일 진입 시 하루치만 조회돼 빈 화면이 되기 쉬워 최근 7일로 결정.
const getDefaultPeriod = () => ({
    startDate: (0, moment_1.default)().subtract(6, 'days').format('YYYY-MM-DD'),
    endDate: (0, moment_1.default)().format('YYYY-MM-DD'),
});
// id 'weeklyWithdrawn' 은 React key/PDF key 용도라 유지 — 의미는 '기간 내 퇴원생'.
const createEmptyWeeklyData = (periodId, periodLabel) => ({
    id: periodId,
    label: periodLabel,
    peopleSummary: [
        { id: 'currentEnrolled', label: '현재 재원생', value: 0, unit: '명' },
        { id: 'weeklyWithdrawn', label: '기간 내 퇴원생', value: 0, unit: '명' },
    ],
    learningSummary: [
        { id: 'attendanceRate', label: '출석률', value: 0 },
        { id: 'testRate', label: '테스트 응시율', value: 0 },
        { id: 'assignmentRate', label: '과제 응시율', value: 0 },
    ],
    attendanceRows: [],
    testRows: [],
    assignmentRows: [],
});
const createEmptyOverallData = () => ({
    peopleSummary: [
        { id: 'seasonRegistered', label: '누적 등록생', value: 0, unit: '명' },
        { id: 'currentEnrolled', label: '현재 재원생', value: 0, unit: '명' },
        { id: 'seasonWithdrawn', label: '누적 퇴원생', value: 0, unit: '명' },
    ],
    sections: {
        attendance: {
            id: 'attendance',
            title: '출석 현황',
            trendLabel: '출석률 추이',
            trendPoints: [],
            rows: [],
        },
        test: {
            id: 'test',
            title: '테스트 현황',
            trendLabel: '응시율 추이',
            trendPoints: [],
            rows: [],
            distribution: [],
        },
        assignment: {
            id: 'assignment',
            title: '과제 현황',
            trendLabel: '응시율 추이',
            trendPoints: [],
            rows: [],
            distribution: [],
        },
    },
});
const normalizeNumber = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
};
const roundRate = (value) => Math.round(normalizeNumber(value));
const sortByStartlineDesc = (items) => [...items].sort((a, b) => (0, moment_1.default)(b?.startline || 0).valueOf() - (0, moment_1.default)(a?.startline || 0).valueOf());
const sortByStartlineAsc = (items) => [...items].sort((a, b) => (0, moment_1.default)(a?.startline || 0).valueOf() - (0, moment_1.default)(b?.startline || 0).valueOf());
const formatDate = (value) => {
    if (!value)
        return '-';
    const date = (0, moment_1.default)(value);
    return date.isValid() ? date.format('YYYY-MM-DD') : value;
};
const getEnrollmentState = (status) => {
    const normalized = `${status || ''}`.toLowerCase();
    const refunded = normalized.includes('inactive') ||
        normalized.includes('refund') ||
        normalized.includes('환불') ||
        normalized.includes('퇴원');
    return {
        refunded,
        enrolledStatus: refunded ? '환불' : '재원',
    };
};
const buildPeopleSummary = (members, isOverall) => {
    if (isOverall) {
        return [
            { id: 'seasonRegistered', label: '누적 등록생', value: normalizeNumber(members?.total_count), unit: '명' },
            { id: 'currentEnrolled', label: '현재 재원생', value: normalizeNumber(members?.active_count), unit: '명' },
            { id: 'seasonWithdrawn', label: '누적 퇴원생', value: normalizeNumber(members?.inactive_count), unit: '명' },
        ];
    }
    return [
        { id: 'currentEnrolled', label: '현재 재원생', value: normalizeNumber(members?.active_count), unit: '명' },
        { id: 'weeklyWithdrawn', label: '기간 내 퇴원생', value: normalizeNumber(members?.inactive_count), unit: '명' },
    ];
};
const buildLearningSummary = (summary) => [
    { id: 'attendanceRate', label: '출석률', value: roundRate(summary?.conference_rate) },
    { id: 'testRate', label: '테스트 응시율', value: roundRate(summary?.test_rate) },
    { id: 'assignmentRate', label: '과제 응시율', value: roundRate(summary?.assignment_rate) },
];
const mapConferenceRows = (items = []) => sortByStartlineDesc(items).map(item => {
    const { refunded, enrolledStatus } = getEnrollmentState(item.status);
    return {
        id: item.conference_id || `${item.member_id}-${item.startline}`,
        date: formatDate(item.startline),
        className: item.conference_name || '-',
        studentName: item.member_name || '-',
        studentId: item.identifier || item.member_id || '-',
        status: item.late ? 'late' : item.done ? 'attend' : 'absent',
        durationMinutes: normalizeNumber(item.attend_time) > 0 ? normalizeNumber(item.attend_time) : null,
        enrolledStatus,
        refunded,
        conferenceId: item.conference_id,
    };
});
const mapTestRows = (items = []) => sortByStartlineDesc(items).map(item => {
    const { refunded, enrolledStatus } = getEnrollmentState(item.status);
    return {
        id: item.test_id || `${item.member_id}-${item.startline}`,
        date: formatDate(item.startline),
        title: item.test_name || '-',
        studentName: item.member_name || '-',
        studentId: item.identifier || item.member_id || '-',
        status: item.done ? 'submit' : 'not-submit',
        score: item.done ? normalizeNumber(item.score) : null,
        enrolledStatus,
        refunded,
        linkId: item.test_id,
    };
});
const mapPieDistribution = (distribution) => Object.entries(distribution?.optional || {})
    .filter(([, value]) => normalizeNumber(value) > 0)
    .map(([label, value], index) => ({
    id: `${label}-${index}`,
    label,
    value: normalizeNumber(value),
    color: PIE_CHART_COLORS[index % PIE_CHART_COLORS.length],
}));
const buildAttendanceOverallSection = (items = []) => {
    const ascendingItems = sortByStartlineAsc(items);
    const trendPoints = ascendingItems.map((item, index) => ({
        id: item.conference_id || `attendance-week-${index + 1}`,
        label: `${index + 1}주차`,
        value: roundRate(item.rate),
    }));
    const rows = [...ascendingItems]
        .reverse()
        .map((item, reverseIndex) => {
        const weekLabel = `${ascendingItems.length - reverseIndex}주차`;
        const doneCount = normalizeNumber(item.done);
        const lateCount = normalizeNumber(item.late);
        const targetCount = normalizeNumber(item.target);
        return {
            id: item.conference_id || `${weekLabel}-${item.startline}`,
            weekLabel,
            date: formatDate(item.startline),
            className: item.conference_name || '-',
            // 전체 현황 출석 매핑(스펙): 수업대상=target, 출석=done, 지각=late,
            // 결석=target-done-late, 출석률=rate.
            targetCount,
            attendCount: doneCount,
            lateCount,
            absentCount: Math.max(0, targetCount - doneCount - lateCount),
            rate: roundRate(item.rate),
        };
    });
    return { trendPoints, rows };
};
const buildExamOverallSection = (items = [], distribution) => {
    const ascendingItems = sortByStartlineAsc(items);
    const trendPoints = ascendingItems.map((item, index) => ({
        id: item.test_id || `exam-week-${index + 1}`,
        label: `${index + 1}주차`,
        value: roundRate(item.rate),
    }));
    const rows = [...ascendingItems]
        .reverse()
        .map((item, reverseIndex) => {
        const weekLabel = `${ascendingItems.length - reverseIndex}주차`;
        const targetCount = normalizeNumber(item.target);
        const submitCount = normalizeNumber(item.done);
        return {
            id: item.test_id || `${weekLabel}-${item.startline}`,
            weekLabel,
            date: formatDate(item.startline),
            title: item.test_name || '-',
            targetCount,
            submitCount,
            // 선택과목 응시 인원(셀 값)은 서버(done_by_optional)의 "그 테스트의 실제 선택과목" 키만 사용 —
            // 특정 과목(수학) 선택과목을 기본값으로 깔면 국어 등 다른 과목 테스트에 엉뚱한
            // 선택과목이 노출된다(실사고: 국어인데 미적분/확통 표시).
            subjectCounts: { ...(item.done_by_optional || {}) },
            notSubmitCount: Math.max(0, targetCount - submitCount),
            rate: roundRate(item.rate),
        };
    });
    return {
        trendPoints,
        rows,
        distribution: mapPieDistribution(distribution),
        // 선택과목 "컬럼" 소스는 기본형(OMR)만 집계하는 tests/optional 키(서버 2026-07-29 변경).
        // total/tests(행)는 자유형(OMR-free)도 포함해 done_by_optional 에 임의 선택과목이 실려
        // 오므로, 행 합집합으로 컬럼을 만들면 자유형 과목이 컬럼으로 샌다(서버 안내 사고).
        optionalSubjects: Object.keys(distribution?.optional || {}),
    };
};
const getAttendanceQueryFilters = (statuses) => {
    const statusSet = new Set(statuses);
    // 출결상태 필터 → API(state/conferences) 요청 매핑(스펙). attend=출석, late=지각, absent=결석.
    // 값(true/false)으로 요청한다. 8개 조합 전부 명시.
    const hasAttend = statusSet.has('attend');
    const hasLate = statusSet.has('late');
    const hasAbsent = statusSet.has('absent');
    // 출석☑ 지각☑ 결석☑ (전체) / 출석☐ 지각☐ 결석☐ (미선택) → 필터 없음 (유지)
    if (hasAttend && hasLate && hasAbsent)
        return {};
    if (!hasAttend && !hasLate && !hasAbsent)
        return {};
    // 출석☑ 지각☐ 결석☐ → done=true
    if (hasAttend && !hasLate && !hasAbsent)
        return { done: true };
    // 출석☐ 지각☑ 결석☐ → late=true (유지)
    if (!hasAttend && hasLate && !hasAbsent)
        return { late: true };
    // 출석☐ 지각☐ 결석☑ → done=false & late=false
    if (!hasAttend && !hasLate && hasAbsent)
        return { done: false, late: false };
    // 출석☑ 지각☑ 결석☐ → done=true & late=true
    if (hasAttend && hasLate && !hasAbsent)
        return { done: true, late: true };
    // 출석☑ 지각☐ 결석☑ → late=false
    if (hasAttend && !hasLate && hasAbsent)
        return { late: false };
    // 출석☐ 지각☑ 결석☑ → done=false
    if (!hasAttend && hasLate && hasAbsent)
        return { done: false };
    return {};
};
const getExamQueryFilters = (statuses) => {
    const statusSet = new Set(statuses);
    if (statusSet.size === detailStatusDefaults.test.length) {
        return {};
    }
    if (statusSet.size === 1 && statusSet.has('submit')) {
        return { done: true };
    }
    if (statusSet.size === 1 && statusSet.has('not-submit')) {
        return { done: false };
    }
    return {};
};
exports.DSTL006_List = react_1.default.memo(({ isTeacher }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const weeklyFetchSeqRef = react_1.default.useRef(0);
    const weeklyDetailSeqRef = react_1.default.useRef(0);
    // 검색/상태필터로 인한 상세 내역 refetch 로딩 — 전체화면(SHOW_LOADING) 대신 상세 내역 리스트 내부에 표시.
    const [weeklyDetailLoading, setWeeklyDetailLoading] = react_1.default.useState(false);
    const overallFetchSeqRef = react_1.default.useRef(0);
    const previousWeeklyFiltersRef = react_1.default.useRef(null);
    const previousAttendanceStatusesRef = react_1.default.useRef(null);
    const previousTestStatusesRef = react_1.default.useRef(null);
    const previousAssignmentStatusesRef = react_1.default.useRef(null);
    const [activeTab, setActiveTab] = react_1.default.useState('weekly');
    // 조회 기간(시작일~종료일, 'YYYY-MM-DD') — 주차 드롭박스 대체(기간 직접 지정)
    const [period, setPeriod] = react_1.default.useState(getDefaultPeriod);
    const [activeSegment, setActiveSegment] = react_1.default.useState('attendance');
    const [selectedStatusesBySegment, setSelectedStatusesBySegment] = react_1.default.useState(detailStatusDefaults);
    const [includeRefunded, setIncludeRefunded] = react_1.default.useState(false);
    const [keyword, setKeyword] = react_1.default.useState('');
    const [generatedAt, setGeneratedAt] = react_1.default.useState(formatCurrentDateTime());
    // 시작일 변경 — 시작일 > 종료일이면 종료일을 시작일로 자동 보정(DSTS004 DateRangeSelector 관례)
    const handleChangePeriodStart = react_1.default.useCallback((value) => {
        if (!value)
            return; // 빈 값(지움)은 무시 — 마지막 유효 기간 유지
        setPeriod(prev => ({
            startDate: value,
            endDate: prev.endDate && (0, moment_1.default)(value).isAfter(prev.endDate, 'day') ? value : prev.endDate,
        }));
    }, []);
    // 종료일 변경 — 종료일 < 시작일이면 시작일로 자동 보정
    const handleChangePeriodEnd = react_1.default.useCallback((value) => {
        if (!value)
            return;
        setPeriod(prev => ({
            startDate: prev.startDate,
            endDate: prev.startDate && (0, moment_1.default)(value).isBefore(prev.startDate, 'day') ? prev.startDate : value,
        }));
    }, []);
    // 기간 라벨 — 'N주차' 대체 표기(PDF 헤더/파일명)
    const periodLabel = react_1.default.useMemo(() => `${(0, moment_1.default)(period.startDate).format('YYYY.MM.DD')} ~ ${(0, moment_1.default)(period.endDate).format('YYYY.MM.DD')}`, [period.startDate, period.endDate]);
    const selectedStatuses = selectedStatusesBySegment[activeSegment];
    // 검색어(keyword)는 서버 재조회 없이 클라이언트 필터(WeeklyStatusSection)로만 처리한다.
    // 멤버 목록·요약·세그먼트 데이터는 주차 전체가 이미 로드되어 있어(페이지네이션 없음),
    // studentName/studentId 로 즉시 걸러내면 되므로 매 입력마다 서버 refetch/스피너가 뜰 필요가 없다.
    // (PDF 내보내기 필터 표기에는 현재 입력값을 그대로 사용)
    const trimmedKeyword = keyword.trim();
    const weeklyFiltersKey = react_1.default.useMemo(() => JSON.stringify({ includeRefunded }), [includeRefunded]);
    const attendanceStatusesKey = react_1.default.useMemo(() => selectedStatusesBySegment.attendance.join(','), [selectedStatusesBySegment.attendance]);
    const testStatusesKey = react_1.default.useMemo(() => selectedStatusesBySegment.test.join(','), [selectedStatusesBySegment.test]);
    const assignmentStatusesKey = react_1.default.useMemo(() => selectedStatusesBySegment.assignment.join(','), [selectedStatusesBySegment.assignment]);
    // 지정 기간을 그대로 API 로 — 시작일 00:00 / 종료일 23:59 (관례: 'YYYY-MM-DDTHH:mm:ssZ')
    const weeklyBaseParams = react_1.default.useMemo(() => ({
        start_after: (0, moment_1.default)(period.startDate, 'YYYY-MM-DD').startOf('day').format('YYYY-MM-DDTHH:mm:ssZ'),
        start_before: (0, moment_1.default)(period.endDate, 'YYYY-MM-DD').endOf('day').format('YYYY-MM-DDTHH:mm:ssZ'),
    }), [period.startDate, period.endDate]);
    // member(검색어) 서버 필터 제거 — 검색은 클라이언트 필터로만 처리(위 weeklyFiltersKey 주석 참고).
    const weeklyAttendanceParams = react_1.default.useMemo(() => ({
        ...weeklyBaseParams,
        with_inactive: includeRefunded || undefined,
        ...getAttendanceQueryFilters(selectedStatusesBySegment.attendance),
    }), [includeRefunded, selectedStatusesBySegment.attendance, weeklyBaseParams]);
    const weeklyTestParams = react_1.default.useMemo(() => ({
        ...weeklyBaseParams,
        with_inactive: includeRefunded || undefined,
        assignment: false,
        ...getExamQueryFilters(selectedStatusesBySegment.test),
    }), [includeRefunded, selectedStatusesBySegment.test, weeklyBaseParams]);
    const weeklyAssignmentParams = react_1.default.useMemo(() => ({
        ...weeklyBaseParams,
        with_inactive: includeRefunded || undefined,
        assignment: true,
        ...getExamQueryFilters(selectedStatusesBySegment.assignment),
    }), [includeRefunded, selectedStatusesBySegment.assignment, weeklyBaseParams]);
    const handleChangeSegment = (segment) => {
        setActiveSegment(segment);
    };
    const handleChangeSelectedStatuses = (segment, statuses) => {
        setSelectedStatusesBySegment(prev => ({
            ...prev,
            [segment]: statuses,
        }));
    };
    const handleScoreClick = (row, type) => {
        dispatch((0, action_1.updateMenu)(isTeacher ? 'learningManagement' : 'myRoom', { menu: type, detail: 'detail' }, row.linkId, type === 'test' ? { initialBigTab: 'testResult', fromStudentStatus: true } : undefined));
    };
    const { data: weeklyMembersData, refetch: refetchWeeklyMembers, } = (0, server_1.useStateWeeklyMembers)(weeklyBaseParams);
    const { data: weeklySummaryData, refetch: refetchWeeklySummary, } = (0, server_1.useStateWeeklySummary)(weeklyBaseParams);
    const { data: weeklyAttendanceData, refetch: refetchWeeklyAttendance, } = (0, server_1.useStateWeeklyConferences)(weeklyAttendanceParams);
    const { data: weeklyTestData, refetch: refetchWeeklyTests, } = (0, server_1.useStateWeeklyTests)(weeklyTestParams);
    const { data: weeklyAssignmentData, refetch: refetchWeeklyAssignments, } = (0, server_1.useStateWeeklyTests)(weeklyAssignmentParams);
    const { data: totalMembersData, refetch: refetchTotalMembers, } = (0, server_1.useStateTotalMembers)();
    const { data: totalAttendanceData, refetch: refetchTotalAttendance, } = (0, server_1.useStateTotalConferences)();
    const { data: totalTestData, refetch: refetchTotalTests, } = (0, server_1.useStateTotalTests)({ assignment: false });
    const { data: totalAssignmentData, refetch: refetchTotalAssignments, } = (0, server_1.useStateTotalTests)({ assignment: true });
    const { data: totalTestOptionalData, refetch: refetchTotalTestOptional, } = (0, server_1.useStateTotalTestsOptional)({ assignment: false });
    const { data: totalAssignmentOptionalData, refetch: refetchTotalAssignmentOptional, } = (0, server_1.useStateTotalTestsOptional)({ assignment: true });
    const runWeeklyRefetches = react_1.default.useCallback(async (refetchers, inline = false) => {
        // inline=true(검색/상태필터): 상세 내역 리스트 내부 로딩. false(초기·주차 로드): 전체화면 로딩.
        // 두 로딩은 서로 다른 seq ref 로 관리해, 한쪽이 끝날 때 다른쪽 로딩이 꺼지지 않고 남는 문제를 방지.
        const seqRef = inline ? weeklyDetailSeqRef : weeklyFetchSeqRef;
        const seq = ++seqRef.current;
        if (inline)
            setWeeklyDetailLoading(true);
        else
            await APP.eventManager.publish('SHOW_LOADING', true);
        try {
            const results = await Promise.allSettled(refetchers.map(refetch => refetch()));
            if (seqRef.current === seq && results.some(result => result.status === 'fulfilled')) {
                setGeneratedAt(formatCurrentDateTime());
            }
        }
        finally {
            if (seqRef.current === seq) {
                if (inline)
                    setWeeklyDetailLoading(false);
                else
                    await APP.eventManager.publish('SHOW_LOADING', false);
            }
        }
    }, []);
    react_1.default.useEffect(() => {
        if (!period.startDate || !period.endDate || activeTab !== 'weekly')
            return;
        // 네이티브 date input 은 키보드 세그먼트 편집 시 change 가 연발되므로
        // 300ms 디바운스로 전체화면 로딩 재조회 연타를 방지한다.
        const timer = setTimeout(() => {
            previousWeeklyFiltersRef.current = weeklyFiltersKey;
            previousAttendanceStatusesRef.current = attendanceStatusesKey;
            previousTestStatusesRef.current = testStatusesKey;
            previousAssignmentStatusesRef.current = assignmentStatusesKey;
            void runWeeklyRefetches([
                refetchWeeklyMembers,
                refetchWeeklySummary,
                refetchWeeklyAttendance,
                refetchWeeklyTests,
                refetchWeeklyAssignments,
            ]);
        }, 300);
        return () => clearTimeout(timer);
    }, [
        activeTab,
        period.startDate,
        period.endDate,
        refetchWeeklyAssignments,
        refetchWeeklyAttendance,
        refetchWeeklyMembers,
        refetchWeeklySummary,
        refetchWeeklyTests,
        runWeeklyRefetches,
    ]);
    react_1.default.useEffect(() => {
        if (activeTab !== 'weekly')
            return;
        if (previousWeeklyFiltersRef.current === null) {
            previousWeeklyFiltersRef.current = weeklyFiltersKey;
            return;
        }
        if (previousWeeklyFiltersRef.current === weeklyFiltersKey)
            return;
        previousWeeklyFiltersRef.current = weeklyFiltersKey;
        void runWeeklyRefetches([
            refetchWeeklyAttendance,
            refetchWeeklyTests,
            refetchWeeklyAssignments,
        ], true);
    }, [
        activeTab,
        includeRefunded,
        refetchWeeklyAssignments,
        refetchWeeklyAttendance,
        refetchWeeklyTests,
        weeklyFiltersKey,
        runWeeklyRefetches,
    ]);
    react_1.default.useEffect(() => {
        if (activeTab !== 'weekly')
            return;
        if (previousAttendanceStatusesRef.current === null) {
            previousAttendanceStatusesRef.current = attendanceStatusesKey;
            return;
        }
        if (previousAttendanceStatusesRef.current === attendanceStatusesKey)
            return;
        previousAttendanceStatusesRef.current = attendanceStatusesKey;
        void runWeeklyRefetches([refetchWeeklyAttendance], true);
    }, [
        activeTab,
        attendanceStatusesKey,
        refetchWeeklyAttendance,
        runWeeklyRefetches,
    ]);
    react_1.default.useEffect(() => {
        if (activeTab !== 'weekly')
            return;
        if (previousTestStatusesRef.current === null) {
            previousTestStatusesRef.current = testStatusesKey;
            return;
        }
        if (previousTestStatusesRef.current === testStatusesKey)
            return;
        previousTestStatusesRef.current = testStatusesKey;
        void runWeeklyRefetches([refetchWeeklyTests], true);
    }, [
        activeTab,
        refetchWeeklyTests,
        runWeeklyRefetches,
        testStatusesKey,
    ]);
    react_1.default.useEffect(() => {
        if (activeTab !== 'weekly')
            return;
        if (previousAssignmentStatusesRef.current === null) {
            previousAssignmentStatusesRef.current = assignmentStatusesKey;
            return;
        }
        if (previousAssignmentStatusesRef.current === assignmentStatusesKey)
            return;
        previousAssignmentStatusesRef.current = assignmentStatusesKey;
        void runWeeklyRefetches([refetchWeeklyAssignments], true);
    }, [
        activeTab,
        assignmentStatusesKey,
        refetchWeeklyAssignments,
        runWeeklyRefetches,
    ]);
    react_1.default.useEffect(() => {
        if (activeTab !== 'overall')
            return;
        let isMounted = true;
        const seq = ++overallFetchSeqRef.current;
        const fetchOverallData = async () => {
            await APP.eventManager.publish('SHOW_LOADING', true);
            try {
                const results = await Promise.allSettled([
                    refetchTotalMembers(),
                    refetchTotalAttendance(),
                    refetchTotalTests(),
                    refetchTotalAssignments(),
                    refetchTotalTestOptional(),
                    refetchTotalAssignmentOptional(),
                ]);
                if (isMounted &&
                    overallFetchSeqRef.current === seq &&
                    results.some(result => result.status === 'fulfilled')) {
                    setGeneratedAt(formatCurrentDateTime());
                }
            }
            finally {
                if (isMounted && overallFetchSeqRef.current === seq) {
                    await APP.eventManager.publish('SHOW_LOADING', false);
                }
            }
        };
        void fetchOverallData();
        return () => {
            isMounted = false;
        };
    }, [
        activeTab,
        refetchTotalAssignmentOptional,
        refetchTotalAssignments,
        refetchTotalAttendance,
        refetchTotalMembers,
        refetchTotalTestOptional,
        refetchTotalTests,
    ]);
    const weeklyData = react_1.default.useMemo(() => {
        const emptyWeeklyData = createEmptyWeeklyData(`${period.startDate}_${period.endDate}`, periodLabel);
        return {
            ...emptyWeeklyData,
            peopleSummary: buildPeopleSummary(weeklyMembersData, false),
            learningSummary: buildLearningSummary(weeklySummaryData),
            attendanceRows: mapConferenceRows(weeklyAttendanceData?.items || []),
            testRows: mapTestRows(weeklyTestData?.items || []),
            assignmentRows: mapTestRows(weeklyAssignmentData?.items || []),
        };
    }, [
        period.startDate,
        period.endDate,
        periodLabel,
        weeklyAssignmentData,
        weeklyAttendanceData,
        weeklyMembersData,
        weeklySummaryData,
        weeklyTestData,
    ]);
    const overallData = react_1.default.useMemo(() => {
        const emptyOverallData = createEmptyOverallData();
        const attendanceSection = buildAttendanceOverallSection(totalAttendanceData?.items || []);
        const testSection = buildExamOverallSection(totalTestData?.items || [], totalTestOptionalData);
        const assignmentSection = buildExamOverallSection(totalAssignmentData?.items || [], totalAssignmentOptionalData);
        return {
            ...emptyOverallData,
            peopleSummary: buildPeopleSummary(totalMembersData, true),
            sections: {
                attendance: {
                    ...emptyOverallData.sections.attendance,
                    trendPoints: attendanceSection.trendPoints,
                    rows: attendanceSection.rows,
                },
                test: {
                    ...emptyOverallData.sections.test,
                    trendPoints: testSection.trendPoints,
                    rows: testSection.rows,
                    distribution: testSection.distribution,
                    optionalSubjects: testSection.optionalSubjects,
                },
                assignment: {
                    ...emptyOverallData.sections.assignment,
                    trendPoints: assignmentSection.trendPoints,
                    rows: assignmentSection.rows,
                    distribution: assignmentSection.distribution,
                    optionalSubjects: assignmentSection.optionalSubjects,
                },
            },
        };
    }, [
        totalAssignmentData,
        totalAssignmentOptionalData,
        totalAttendanceData,
        totalMembersData,
        totalTestData,
        totalTestOptionalData,
    ]);
    const handlePrint = react_1.default.useCallback(async () => {
        // 기간 라벨의 공백/'.'/'~' 파일명 안전화(YYYYMMDD-YYYYMMDD)
        const filename = `student-status-${(0, pdf_1.toPeriodFileToken)(weeklyData.label)}.pdf`;
        const pdfData = await (0, pdf_1.openStudentStatusPdf)({
            generatedAt,
            selectedWeek: weeklyData,
            filters: {
                activeSegment,
                statuses: selectedStatusesBySegment,
                includeRefunded,
                keyword: trimmedKeyword,
            },
        });
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            component: ScoreReportViewer_1.ScoreReportViewer,
            componentProps: {
                pdfData,
                filename,
                title: filename.replace(/\.pdf$/i, ''),
                onDownload: () => (0, pdf_1.downloadStudentStatusPdf)({
                    generatedAt,
                    selectedWeek: weeklyData,
                    filters: {
                        activeSegment,
                        statuses: selectedStatusesBySegment,
                        includeRefunded,
                        keyword: trimmedKeyword,
                    },
                }),
            },
            title: '학생 현황',
            width: 900,
        });
    }, [
        activeSegment,
        generatedAt,
        includeRefunded,
        selectedStatusesBySegment,
        trimmedKeyword,
        weeklyData,
    ]);
    const tabs = [
        {
            id: 'weekly',
            title: '기간별 현황',
            content: (react_1.default.createElement("div", { className: "student-status-wrap" },
                react_1.default.createElement(StudentStatusControls_1.StudentStatusControls, { isMobile: isMobile, isTablet: isTablet, generatedAt: generatedAt, periodStartDate: period.startDate, periodEndDate: period.endDate, onChangePeriodStart: handleChangePeriodStart, onChangePeriodEnd: handleChangePeriodEnd, onPrint: handlePrint }),
                react_1.default.createElement(WeeklyStatusSection_1.WeeklyStatusSection, { weeklyData: weeklyData, detailLoading: weeklyDetailLoading, activeSegment: activeSegment, onChangeSegment: handleChangeSegment, selectedStatuses: selectedStatuses, onChangeSelectedStatuses: handleChangeSelectedStatuses, includeRefunded: includeRefunded, onChangeIncludeRefunded: setIncludeRefunded, keyword: keyword, onChangeKeyword: setKeyword, isMobile: isMobile, isTablet: isTablet, isDesktop: isDesktop, onScoreClick: handleScoreClick }))),
        },
        {
            id: 'overall',
            title: '전체 현황',
            content: (react_1.default.createElement("div", { className: "student-status-wrap" },
                react_1.default.createElement(StudentStatusControls_1.StudentStatusControls, { isMobile: isMobile, isTablet: isTablet, generatedAt: generatedAt, periodStartDate: period.startDate, periodEndDate: period.endDate, onChangePeriodStart: handleChangePeriodStart, onChangePeriodEnd: handleChangePeriodEnd, onPrint: handlePrint, showControlsRight: false }),
                react_1.default.createElement(OverallStatusSection_1.OverallStatusSection, { overallData: overallData, isMobile: isMobile, isTablet: isTablet, isDesktop: isDesktop }))),
        },
    ];
    return (react_1.default.createElement(DSTL006ListStyled, { className: 'student-status wrapper-padding', "$isMobile": isMobile, "$isTablet": isTablet, "$isDesktop": isDesktop },
        react_1.default.createElement(layout_1.BigTabLayout, { tabs: tabs, activeTabId: activeTab, onTabChange: tabId => setActiveTab(tabId) })));
});
